import { render, staticRenderFns } from "./PayPending.vue?vue&type=template&id=671ef915&scoped=true&"
import script from "./PayPending.vue?vue&type=script&lang=js&"
export * from "./PayPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ef915",
  null
  
)

export default component.exports